import {useEffect, useState} from 'react'
import { Collapse, message } from 'antd'
import ManagerCards from './ManagerCards'
import LocationMap from './LocationMap'
import './Contacts.css'
import { getOfficesFromLinyuan } from '../../common/javascripts/common.js'

export default function Contacts(props) {

  const [list, setList] = useState([]);
  const lang = props.lang; //声明当前语言选择，0中文，1英文
  useEffect(() => {
      async function load() {
        try {
          const page = await getOfficesFromLinyuan(1, 100, lang);
          const data = page.list || [];
          const dataOrdered = data.slice().sort((a, b) => Number(a.id) - Number(b.id));
          setList(dataOrdered);
        } catch (e) {
          console.error('Error fetching offices from linyuanApi', e);
          const msg = lang === 0 ? '加载办公地点失败，请稍后重试' : 'Failed to load offices, please try again later';
          message.error(msg);
          setList([]);
        }
      }
      load();
  }, [lang]);
  const {Panel} = Collapse;
  
  return (
    <div className='contacts_container'>
      <Collapse defaultActiveKey={'1'}
        style={
          {
            'backgroundColor' : 'var(--lynyn-lightBlue)',
            'fontSize' : '20px'
          }

        }
      >
        <Panel header={lang === 0 ? '业务联系人' : 'Business Contacts'} key='1' >
          <ManagerCards lang={lang} />
        </Panel>
      </Collapse>
      {list.map(item => <LocationMap lang={lang} location={item} key={item.id}/> )}
    </div>
  )
}
